document.addEventListener("DOMContentLoaded", function() {
  const maxChars = 220;

  document.querySelectorAll(".richtext-description").forEach(function(container) {

  const content =
    container.querySelector(".metafield-rich_text_field") ||
    container.querySelector(".richtext-content");

  if (!content) return;

  const maxChars = 300;

  const fullHTML = content.innerHTML;
  const temp = document.createElement("div");
  temp.innerHTML = fullHTML;

  const plainText = temp.textContent || temp.innerText || "";
  if (plainText.length <= maxChars) return;

  function truncateHTML(node, limit) {
    let total = 0;
    const clone = node.cloneNode(true);
    let lastTextNode = null;

    function walk(n) {
      const children = Array.from(n.childNodes);
      for (let child of children) {
        if (child.nodeType === Node.TEXT_NODE) {
          if (total + child.textContent.length > limit) {
            child.textContent = child.textContent.slice(0, limit - total);
            lastTextNode = child;
            while (child.nextSibling) child.nextSibling.remove();
            return true;
          } else {
            total += child.textContent.length;
            lastTextNode = child;
          }
        } else if (child.nodeType === Node.ELEMENT_NODE) {
          const done = walk(child);
          if (done) {
            while (child.nextSibling) child.nextSibling.remove();
            return true;
          }
        }
      }
      return false;
    }

    walk(clone);

    if (lastTextNode && lastTextNode.parentNode) {
      const span = document.createElement("span");
      span.innerHTML = `<span class="ellipsis">... </span><a href="#" class="toggle-link">Read more</a>`;
      lastTextNode.parentNode.appendChild(span);
    }

    return clone.innerHTML;
  }

  const truncatedHTML = truncateHTML(temp, maxChars);

  content.innerHTML = `
    <div class="short-version">${truncatedHTML}</div>
    <div class="full-version" style="display:none;">
      ${fullHTML}
      <a href="#" class="toggle-link">Read less</a>
    </div>
  `;

  const shortEl = content.querySelector(".short-version");
  const fullEl = content.querySelector(".full-version");

  content.querySelectorAll(".toggle-link").forEach(link => {
    link.addEventListener("click", function(e) {
      e.preventDefault();
      const expanded = fullEl.style.display === "block";
      fullEl.style.display = expanded ? "none" : "block";
      shortEl.style.display = expanded ? "block" : "none";
    });
  });

});



  // Target the main slider
  var $mainSlider = $('.rq-product-slider-new');

  // Your custom external buttons (adjust class names if needed)
  var $nextBtn = $('.custom_slick-btns .rq-NextArrow');
  var $prevBtn = $('.custom_slick-btns .rq-PrevArrow');

  // ✅ Make sure slider exists
  if ($mainSlider.length) {

    // --- Attach click handlers ---
    $nextBtn.off('click').on('click', function(e){
      e.preventDefault();
      $mainSlider.slick('slickNext');
      updateCustomNav();
    });

    $prevBtn.off('click').on('click', function(e){
      e.preventDefault();
      $mainSlider.slick('slickPrev');
      updateCustomNav();
    });

    // --- Function to enable/disable buttons ---
    function updateCustomNav() {
      var slickObj = $mainSlider.slick('getSlick');
      if (!slickObj) return;

      var current = slickObj.currentSlide;
      var last = slickObj.slideCount - 1;

      if (current === 0) {
        $prevBtn.addClass('disabled').prop('disabled', true);
      } else {
        $prevBtn.removeClass('disabled').prop('disabled', false);
      }

      if (current === last) {
        $nextBtn.addClass('disabled').prop('disabled', true);
      } else {
        $nextBtn.removeClass('disabled').prop('disabled', false);
      }
    }

    // --- Listen for change events ---
    $mainSlider.on('init afterChange reInit', function(){
      updateCustomNav();
    });

    // --- Initialize state ---
    if ($mainSlider.hasClass('slick-initialized')) {
      updateCustomNav();
    }
  }
    
///////
// Toggle search box on button click
$(document).on('click', '.search__button-custom.field__button', function(e) {
  e.stopPropagation();
  $('.search_box_wrapped').toggleClass('active');

  if ($('.search_box_wrapped').hasClass('active')) {
    setTimeout(() => {
      $('#Search-In-Template').focus();
    }, 50);
  }
});

// Prevent closing when clicking inside the search box
$(document).on('click', '.search_box_wrapped', function(e) {
  e.stopPropagation();
});

// Click anywhere outside → hide search box
$(document).on('click', function() {
  $('.search_box_wrapped').removeClass('active');
});






  //////
});


$(document).on('click', '.pc-variants .pc-color', function () {

    const scrollY = window.scrollY;

    /* get clicked index */
    const index = $('.pc-variants .pc-color').index(this);
    if (index < 0) return;

    /* find matching variant radio */
    const $label = $('.varinat-clr').eq(index);
    if (!$label.length) return;

    /* click actual variant */
    $label[0].dispatchEvent(new MouseEvent('click', { bubbles: true }));

    /* restore scroll */
    let tries = 0;
    const restore = () => {
        window.scrollTo(0, scrollY);
        if (++tries < 10) requestAnimationFrame(restore);
    };
    requestAnimationFrame(restore);

});

